export class Address {
  name: string;
  displayName: string;
  company: string;
  address1: string;
  address2: string;
  address3: string;
  isMontovaCompatible: boolean;
}
